import type { Template } from "@/types";

export const PO_04_H0_V4: Template[] = [
    {
        id: "po-04-h0v4-01",
        name: "PO 01 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_01.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 36, y: 215, width: 290, height: 466, rotation: 0, imageRotation: 0 },
            { id: "2", x: 333, y: 215, width: 290, height: 466, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 215, width: 290, height: 466, rotation: 0, imageRotation: 0 },
            { id: "4", x: 927, y: 215, width: 290, height: 466, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-02",
        name: "PO 02 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_02.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 201, width: 308, height: 494, rotation: 0, imageRotation: 0 },
            { id: "2", x: 315, y: 201, width: 308, height: 494, rotation: 0, imageRotation: 0 },
            { id: "3", x: 631, y: 201, width: 308, height: 494, rotation: 0, imageRotation: 0 },
            { id: "4", x: 946, y: 201, width: 307, height: 494, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-03",
        name: "PO 03 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 32, y: 224, width: 278, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 224, width: 278, height: 446, rotation: 0, imageRotation: 0 },
            { id: "3", x: 658, y: 224, width: 278, height: 446, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 224, width: 278, height: 446, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-04",
        name: "PO 04 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 37, y: 181, width: 332, height: 532, rotation: 0, imageRotation: 0 },
            { id: "2", x: 377, y: 274, width: 215, height: 345, rotation: 0, imageRotation: 0 },
            { id: "3", x: 660, y: 274, width: 215, height: 345, rotation: 0, imageRotation: 0 },
            { id: "4", x: 883, y: 181, width: 332, height: 532, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-05",
        name: "PO 05 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 29, y: 147, width: 376, height: 598, rotation: 0, imageRotation: 0 },
            { id: "2", x: 413, y: 147, width: 184, height: 296, rotation: 0, imageRotation: 0 },
            { id: "3", x: 413, y: 451, width: 184, height: 295, rotation: 0, imageRotation: 0 },
            { id: "4", x: 753, y: 147, width: 373, height: 598, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-06",
        name: "PO 06 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 37, y: 42, width: 493, height: 792, rotation: 0, imageRotation: 0 },
            { id: "2", x: 537, y: 515, width: 201, height: 318, rotation: 0, imageRotation: 0 },
            { id: "3", x: 746, y: 515, width: 200, height: 318, rotation: 0, imageRotation: 0 },
            { id: "4", x: 954, y: 515, width: 200, height: 318, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-07",
        name: "PO 07 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 87, y: 85, width: 451, height: 723, rotation: 0, imageRotation: 0 },
            { id: "2", x: 662, y: 184, width: 327, height: 526, rotation: 0, imageRotation: 0 },
            { id: "3", x: 997, y: 85, width: 221, height: 358, rotation: 0, imageRotation: 0 },
            { id: "4", x: 997, y: 451, width: 221, height: 358, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-08",
        name: "PO 08 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 87, y: 85, width: 451, height: 723, rotation: 0, imageRotation: 0 },
            { id: "2", x: 662, y: 85, width: 221, height: 358, rotation: 0, imageRotation: 0 },
            { id: "3", x: 662, y: 451, width: 221, height: 357, rotation: 0, imageRotation: 0 },
            { id: "4", x: 891, y: 184, width: 327, height: 526, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-09",
        name: "PO 09 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 54, y: 83, width: 454, height: 728, rotation: 0, imageRotation: 0 },
            { id: "2", x: 515, y: 83, width: 223, height: 360, rotation: 0, imageRotation: 0 },
            { id: "3", x: 515, y: 451, width: 223, height: 360, rotation: 0, imageRotation: 0 },
            { id: "4", x: 745, y: 83, width: 453, height: 728, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-10",
        name: "PO 10 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 54, y: 83, width: 454, height: 728, rotation: 0, imageRotation: 0 },
            { id: "2", x: 515, y: 83, width: 453, height: 728, rotation: 0, imageRotation: 0 },
            { id: "3", x: 975, y: 83, width: 223, height: 360, rotation: 0, imageRotation: 0 },
            { id: "4", x: 975, y: 451, width: 223, height: 360, rotation: 0, imageRotation: 0 }
        ],
    }
];